import { WelcomeVideo } from '@/components/molecules/Admin/Modals/OnboardingStudent/WelcomeVideo'
import { Calendar } from '@/components/molecules/Admin/Modals/OnboardingStudent/Calendar'
import { Whatsapp } from '@/components/molecules/Admin/Modals/Whatsapp'
import Notification from '@/components/molecules/Admin/Notification'
import DrawerCourse from '@/components/molecules/Admin/DrawerCourse'
import { GoogleCalendar } from '@/components/molecules/Admin/Modals/GoogleCalendar'
import { useUpdateGoogleCalendar } from '@/utils/hooks/useUpdateGoogleCalendar'
import { useShowWhatsappModal } from '@/utils/hooks/useShowWhatsappModal'
import { FeedbackClass } from '@/components/molecules/Admin/Modals/FeedbackClass'
import {
	useShowModals,
	useShowModalsMentorships,
} from '@/utils/hooks/useShowModals'
import { Topbar } from '@layouts/Admin/Topbar'
import { Schedule } from '@/components/molecules/Admin/Modals/Mentorships/Schedule'
import { Status } from '@/components/molecules/Admin/Modals/Status'
import { CancelMentorship } from '@/components/molecules/Admin/Modals/Mentorships/CancelMentorship'
import { StudentFeedback } from '@/components/molecules/Admin/Modals/Mentorships/StudentFeedback'

interface CreditsProps {
	children: React.ReactNode
}

export function CreditsLayout({ children }: CreditsProps) {
	useUpdateGoogleCalendar()

	useShowWhatsappModal()
	useShowModals()

	useShowModalsMentorships()

	return (
		<div className='w-full flex flex-col justify-center items-center overflow-clip bg-zinc-950'>
			<Topbar />
			<div className='flex flex-col w-full min-h-[_calc(100vh_-_98px)] overflow-clip relative'>
				{children}

				<div>
					<img
						src='/imgs/admin/lines-bottom-right.png'
						alt='Emoji'
						className='absolute bottom-0 right-0 w-[550px] h-[900px] opacity-30 2lg:opacity-100'
					/>
				</div>
			</div>

			<DrawerCourse />
			<Notification />

			{/* start of mentorships */}
			<Schedule />
			<CancelMentorship />
			<StudentFeedback disabledOnClose />
			{/* end of mentorships */}

			{/* start of student onboarding */}
			<WelcomeVideo disabledOnClose />
			<Calendar disabledOnClose />
			{/* end of student onboarding */}

			<Whatsapp disabledOnClose />

			<GoogleCalendar disabledOnClose />

			<FeedbackClass disabledOnClose />

			<Status />
		</div>
	)
}
